import { render, staticRenderFns } from "./ZipMediaUpload.vue?vue&type=template&id=383d346a&scoped=true"
import script from "./ZipMediaUpload.vue?vue&type=script&lang=js"
export * from "./ZipMediaUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d346a",
  null
  
)

export default component.exports